import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftSelect from 'components/SoftSelect';

const PackageSelector = ({ baseOptions = null, selectedPackage, setSelectedPackage }) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Si se pasan opciones base, se utilizan y se evita la petición
    if (baseOptions !== null) {
      setOptions(baseOptions);
      setIsLoading(false);
      return;
    }

    // Configuramos el cancel token para axios
    const source = axios.CancelToken.source();

    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/maintenance/packaging-types/`)
      .then(response => {
        const data = response.data;
        // Mapeamos la data para ajustarla al formato que necesita SoftSelect
        const mappedOptions = data.map(option => ({
          label: option.nombre_tipo_embalaje,
          value: option.id_tipo_embalaje,
          ...option,
        }));
        setOptions(mappedOptions);
        setIsLoading(false);
      })
      .catch(err => {
        if (axios.isCancel(err)) {
          console.log('Request canceled:', err.message);
        } else {
          setError(err.message);
          setIsLoading(false);
        }
      });

    // Cleanup: cancelar la petición si el componente se desmonta
    return () => {
      source.cancel('Operation canceled by the user.');
    };
  }, [baseOptions]);

  return (
    <SoftBox>
      <SoftTypography 
        variant="caption"
        fontWeight="bold"
        color="text"
      >
        Packages
      </SoftTypography>
      <SoftSelect
        options={options}
        value={options.find(option => option.value === selectedPackage)}
        onChange={setSelectedPackage}
        isLoading={isLoading}
        placeholder="Seleccione un package"
        error={error}
      />
    </SoftBox>
  );
};

PackageSelector.propTypes = {
  baseOptions: PropTypes.array,
  selectedPackage: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number,
    PropTypes.string,
  ]),
  setSelectedPackage: PropTypes.func.isRequired,
};

export default PackageSelector;
